import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface LeadFollowupSummary {
  leadId: string;
  hasOverdueFollowups: boolean;
  pendingCount: number;
  nextDueAt?: string;
}

export function useLeadFollowupsForList(leadIds: string[]) {
  return useQuery<LeadFollowupSummary[]>({
    queryKey: ['lead-followups-summary', leadIds.join(',')],
    queryFn: async () => {
      if (!leadIds.length) return [];
      const params = new URLSearchParams();
      leadIds.forEach(id => params.append('leadIds', id));
      const res = await api.get<{ summaries: LeadFollowupSummary[] }>(`/leads/followups-summary?${params.toString()}`);
      return res?.summaries ?? [];
    },
    enabled: leadIds.length > 0,
    staleTime: 60_000,
  });
}
